import { jsx as _jsx } from "react/jsx-runtime";
import { Translate } from "@mittwald/flow-components/dist/components/Translate";
/**
 * Shows the menu title (`pages.[path].menu.title`) or the page title
 * (`pages.[path].title`) as fallback
 */
export const MenuTitle = (props) => (_jsx(Translate, { i18n: [
        "menu.title",
        "title",
        {
            breadcrumb: props.breadcrumb,
            ignoreContext: true,
        },
    ] }));
export default MenuTitle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVudVRpdGxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTWVudVRpdGxlL01lbnVUaXRsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxxREFBcUQsQ0FBQztBQUloRjs7O0dBR0c7QUFDSCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQXVCLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUN0RCxLQUFDLFNBQVMsSUFDUixJQUFJLEVBQUU7UUFDSixZQUFZO1FBQ1osT0FBTztRQUNQO1lBQ0UsVUFBVSxFQUFFLEtBQUssQ0FBQyxVQUFVO1lBQzVCLGFBQWEsRUFBRSxJQUFJO1NBQ3BCO0tBQ0YsR0FDRCxDQUNILENBQUM7QUFFRixlQUFlLFNBQVMsQ0FBQyJ9